export default __webpack_public_path__ + "static/media/posto.93a2c0ae.jpg";